export const glassboxErrorEvent = (error) => {
    let Dell = { ...window.Dell } || {};
    function dispatchGbxErrorEvent() {
        document.dispatchEvent(new CustomEvent("GBXErrorReport", {
            detail: {
                "GBX_Error": `${Dell.Metrics.sc.applicationname} = ${error}`, // pass dell.metrics.sc.applicationame=Error Message
            },
            bubbles: true
        }));
    }

    if (typeof _detector !== undefined) //Checks if Glassbox is already loaded and dispatch the event
    {
        dispatchGbxErrorEvent();
    }
    else // if Glassbox is not loaded, listen to GBXDetectorLoaded event and then dispatch the event
    {
        window.addEventListener("GBXDetectorLoaded", function () {
            dispatchGbxErrorEvent();
        });
    }
}

export const glassboxSuccessEvent = (info) => {
    let Dell = { ...window.Dell } || {};
    function dispatchGbxErrorEvent() {
        document.dispatchEvent(new CustomEvent("GBXErrorReport", {
            detail: {
                "GBX_Info": `${Dell.Metrics.sc.applicationname} = ${info}`,
            },
            bubbles: true
        }));
    }

    if (typeof _detector !== undefined) {
        dispatchGbxErrorEvent();
    }
    else {
        window.addEventListener("GBXDetectorLoaded", function () {
            dispatchGbxErrorEvent();
        });
    }
}